<template>
  <div class="specialInspects">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="specialInspects.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="600px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          style="position: relative"
          :model="specialInspects"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="检验项目：">
          <el-input v-model="specialInspects.inspectItem"/>
        </el-form-item>
        <el-form-item label="检验标准：">
          <el-input v-model="specialInspects.inspectStandard"/>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="specialInspects.note" type="textarea"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button type="info" @click="dialogVisible=false">关闭</el-button>
        <el-button :loading="saveLoading" type="primary" @click="reportSave">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";
  import constants from "../../../util/constants";
  export default {
    name: "SpecialInspectsEdit",
    components: {},
    data() {
      return {
        constant,
        constants,
        dialogVisible: false,
        contentLoading: false,
        saveLoading: false,
        specialInspects: {
          pkid: 0,
          masterID: 0,
          inspectItem: "",
          inspectStandard: "",
          attachments: [],
        },
        ruleValidate: {
        },
      };
    },
    methods: {
      open(id) {
        this.dialogVisible = true;
      },
      // getData() {
      //   this.contentLoading = true;
      //   this.$http
      //     .get("basic", `specialInspectsBinds/selectControlBoxReportById/${this.specialInspects.pkid}`)
      //     .then(resp => {
      //       this.specialInspects = resp;
      //       this.contentLoading = false;
      //     });
      // },
      reportSave() {
        // console.log(1111);
        this.$emit("add-success", this.specialInspects);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss">
  .specialInspects {
    .table {
      width: 100%;
      margin: 2% auto;
      border-top: 1px solid #dddddd;
      border-left: 1px solid #dddddd;

      .tableLabel {
        width: 130px;
        padding: 1%;
        background: #f4f7fa;
        border-bottom: 1px solid #dddddd;
      }

      .tableModel {
        width: 20%;
        padding: 1%;
        border-left: 1px solid #dddddd;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
      }
    }
  }

</style>
